import { AxiosInstance } from "axios";
import { User } from "../models/user";

const VALIDATION_API_PREFIX = "/auth/validation";

export async function requestEmailVerificationCode(http: AxiosInstance) {
	const response = await http.post(
		VALIDATION_API_PREFIX + "/request-email-verification-code"
	);

	return response;
}

export async function validateEmailVerificationCode(
	http: AxiosInstance,
	emailVerificationCode: string,
	metaEventId?: string
): Promise<User> {
	const response = await http.post<User, User>(
		VALIDATION_API_PREFIX + "/validate-email-verification-code",
		{
			emailVerificationCode,
			metaEventId,
		}
	);

	return response;
}
